<template>
  <DBox
    :addButton="false"
    :addLink="false"
    :id="'cmp-booking-artists-artist-requirement'"
  >
    <TextField2
      id="default_techrider_eng"
      :textarea="true"
      :height="145"
      :label="$dft.capHead($t('techrider'))"
      :disabled="selectedArtist.disabled"
      :value="selectedArtist.default_techrider_eng"
      @change="onTextFieldValueChange"
    />
    <TextField2
      id="default_catering_eng"
      :textarea="true"
      :height="145"
      :label="$dft.capHead($t('catering'))"
      :disabled="selectedArtist.disabled"
      :value="selectedArtist.default_catering_eng"
      @change="onTextFieldValueChange"
    />
    <TextField2
      id="default_hotel_eng"
      :textarea="true"
      :height="145"
      :label="$dft.capHead($t('hotel_classification'))"
      :disabled="selectedArtist.disabled"
      :value="selectedArtist.default_hotel_eng"
      @change="onTextFieldValueChange"
    />
    <TextField2
      id="default_travel_eng"
      :textarea="true"
      :height="145"
      :bb="'0'"
      :label="$dft.capHead($t('travel'))"
      :disabled="selectedArtist.disabled"
      :value="selectedArtist.default_travel_eng"
      @change="onTextFieldValueChange"
    />
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import TextField from "@plugins/text-field/text-field";
import Dropdown from "@plugins/dropdown/dropdown";
import { ArtistService } from "../../../services/artists";
import { EventHooks } from "../../../../../plugins/text-field";

export default {
  components: {
    DBox,
    TextField,
    Dropdown,
  },
  props: {
    selectedArtist: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      // textFieldConfig: {
      //   height: 142,
      //   showEditIconOnHover: false,
      //   box: true,
      //   showValidationIcons: true,

      //   validationEvent: EventHooks.OnBlur,
      //   valueChangedEvent: EventHooks.OnBlur,
      // },
      notes: "",
      countries: [],
      selectedCountry: null,
      // Mark: Data
    };
  },
  mounted: function () {},
  watch: {},
  computed: {},
  methods: {
    onTextFieldValueChange: function ({ name, value }) {
      // console.log(name, value);
      this.$emit("changed", { name, value });
    },
    // Mark: Methods
  },
};
</script>

<style lang="scss">
.cmp-booking-artists-artist-requirement {
  // .dt-input-box--container {
  //   margin: 5px;
  // }
  .fc2 {
    --fc2-lw: 90px !important;
    label {
      &.fc2-label {
        white-space: pre-wrap !important;
      }
    }
  }
}
</style>
